'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';
import Image from 'next/image';
import { Heading } from '@/components/ui/Heading';
import Link from 'next/link';
import { SwiperListProps } from '@/core/models/slider-model';
import { useDictionary } from '@/core/hooks/use-dictionary';
import { ArrowLeftIcon } from 'lucide-react';

export default function SwiperList({ data }: SwiperListProps) {
  const { dictionary } = useDictionary();

  const items = Array.isArray(data.items)
    ? data.items
    : Array.isArray(data.sliderItems)
      ? data.sliderItems
      : [];
  return (
    <div className="w-full col-span-12">
      <div className="flex justify-between items-center mb-2 max-md:flex-col max-md:items-start">
        <div>
          <Heading level={3}>{data.title}</Heading>
          <p className="text-primary-600">{data.description}</p>
        </div>
        {data.link && (
          <Link className="text-primary-600 flex items-center gap-1" href={data.link}>
            {dictionary.ui?.pages.seeAll}
            <ArrowLeftIcon className="stroke-1 size-4 ltr:rotate-180" />
          </Link>
        )}
      </div>
      <Swiper
        modules={[Scrollbar]}
        spaceBetween={16}
        slidesPerView="auto"
        scrollbar={{
          draggable: true,
          dragSize: 100,
        }}
        className="w-full"
        style={{
          paddingBottom: '70px',
        }}
      >
        {items.map((item, index) => {
          const Content = (
            <div>
              <div
                className="w-full h-full mb-2 relative"
                style={{ width: '300px', height: '360px' }}
              >
                {(item.image?.url ||
                  item.image_info?.url) && (
                    <Image
                      src={
                        item.image?.url ||
                        item.image_info?.url
                      }
                      alt={item.title || ''}
                      fill
                      className="object-cover rounded-md"
                    />
                  )}
              </div>
              <Heading level={4}>{item.title}</Heading>
              <p className="text-primary-600">{item.description}</p>
            </div>
          );

          return (
            <SwiperSlide
              key={index}
              style={{ width: '300px', height: '360px' }}
            >
              {item.link ? <Link href={item.link}>{Content}</Link> : Content}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}
